import * as SentryType from '@sentry/browser'

declare global {
  interface Window {
    Sentry: typeof SentryType | undefined
  }
}

/**
 * Returns the Sentry global Sentry instance if available
 */
export default function getSentry() {
  if (typeof window === undefined) {
    return
  }
  return window.Sentry
}
